import { lng } from '@ads/front-core/locales'

export interface PreviewSliderItem {
  name: string
  src: string
}

export type PreviewItemType = 'ecommerce' | 'mailing' | 'banners' | 'native'

export const sliderEcommerce: PreviewSliderItem[] = [
  {
    name: lng('landing:dynamicDisplayHorizontal'),
    src: '/img/landing/ecommerce/ecommerce_1.png',
  },
  {
    name: lng('landing:dynamicDisplayVertical'),
    src: '/img/landing/ecommerce/ecommerce_2.png',
  },
  {
    name: lng('landing:dynamicDisplayVertical'),
    src: '/img/landing/ecommerce/ecommerce_3.png',
  },
]

export const sliderMailing: PreviewSliderItem[] = [
  {
    name: lng('landing:mailingMailbox'),
    src: '/img/landing/mailing/mailing_1.png',
  },
  {
    name: lng('landing:mailingMailbox'),
    src: '/img/landing/mailing/mailing_2.png',
  },
  {
    name: lng('landing:mailingTemplates'),
    src: '/img/landing/mailing/mailing_3.png',
  },
  {
    name: lng('landing:mailingStudio'),
    src: '/img/landing/mailing/mailing_4.png',
  },
]

export const sliderBanners: PreviewSliderItem[] = [
  { name: lng('landing:banner'), src: '/img/landing/banner/banner_1.png' },
  { name: lng('landing:banner'), src: '/img/landing/banner/banner_2.png' },
  { name: lng('landing:banner'), src: '/img/landing/banner/banner_3.png' },
]

export const sliderNative: PreviewSliderItem[] = [
  { name: lng('landing:advNative'), src: '/img/landing/native/native_1.png' },
  { name: lng('landing:advNative'), src: '/img/landing/native/native_2.png' },
  {
    name: lng('landing:advNativeDifferentVersions'),
    src: '/img/landing/native/native_3.png',
  },
]
